/**
 * Camino Design System Spacing
 * Source: Design system camino (1).pdf
 *
 * Based on a 4px base unit system.
 * Uses abbreviation naming to align with font size tokens.
 */

export const spacing = {
  none: "0px",
  xs: "4px", // tiny
  sm: "8px", // small
  md: "12px",
  lg: "16px", // medium (standard)
  xl: "24px", // large
  "2xl": "32px", // extraLarge
  "3xl": "48px", // huge
} as const;

/**
 * Numeric spacing scale for Chakra UI
 * Maps to the abbreviation names above
 */
export const spacingScale = {
  0: "0px", // none
  1: "4px", // xs
  2: "8px", // sm
  3: "12px", // md
  4: "16px", // lg
  6: "24px", // xl
  8: "32px", // 2xl
  12: "48px", // 3xl
} as const;

/**
 * Extended spacing scale with all 4px increments
 * For fine-grained control when needed
 */
export const spacingRaw = {
  0: "0px",
  1: "4px",
  2: "8px",
  3: "12px",
  4: "16px",
  5: "20px",
  6: "24px",
  7: "28px",
  8: "32px",
  9: "36px",
  10: "40px",
  11: "44px",
  12: "48px",
  14: "56px",
  16: "64px",
  20: "80px",
  24: "96px",
} as const;

export type Spacing = typeof spacing;
export type SpacingScale = typeof spacingScale;
export type SpacingRaw = typeof spacingRaw;

export default spacing;
